export default [
  {
    path: '/ugc/List',
    name: 'ugc-list',
    meta: {
      requiresAuth: true,
      title: 'UGC'
    },
    component: () =>
      import(/* webpackChunkName: "profile" */ '@/components/ugc/List.vue')
  }

]
